import * as actionTypes from '../actions/actionTypes'
import { vars } from '../../components/common'

const initialState = {
  primaryColor: vars.main_blue,
  secondaryColor: vars.white,
  fontWeight: 400,
  botBubbleBG: vars.message_bubble_bot,
  userBubbleBG: vars.message_bubble_user,
  linkColor: vars.main_blue
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.SET_THEME:
      return { ...state, ...action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/themeReducer.js